import { styled } from '@/src/stitches.config'

export const PostItWrapper = styled('div', {
    width: '325px',
    height: '325px',
    '@media (min-width: 765px)': {
        mt: '18%',
    },
})

export const FormWrapper = styled('div', {
    width: '$default',
    maxWidth: '100%',
    margin: 'auto',
    variants: {
        variant: {
            consumer: {
                display: 'flex',
                fd: 'column',
                jc: 'space-between',
                ai: 'center',
                '@media (min-width:765px)': {
                    fd: 'row',
                    ai: 'unset',
                },
            },
            corporate: {
                paddingBottom: '5rem',
            },
        },
    },
})

export const FormRowWrapper = styled('div', {
    display: 'flex',
    alignItems: 'left',
    gap: '.3em',
    marginTop: '1em',
    flexDirection: 'column',
})

export const ErrorWrapper = styled('div', {
    width: '$default',
    maxWidth: '90vw',
    margin: '$8 auto',
    '& h1': {
        mb: 0,
    },
    '& p': {
        fontSize: '$6',
        mb: '50px',
    },
    '& a': {
        width: '70%',
        maxWidth: '275px',
        mt: '10px',
    },
})

export const LeftContent = styled('div', {
    width: '$defaultMax',
    py: '25px',
    '@media (min-width:765px)': {
        width: '45%',
        pl: '3%',
        py: '40px',
    },
    '@xl': {
        pl: 'unset',
    },
    '& p': {
        mb: '30px',
    },
})
